<template>

    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button class="pill next-pill-button" @click="skip">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container onboarding">
            <PageTitle :title="pageText[addressPageType].pageTitle" :subtitle="pageText[addressPageType].formText " showIcon />
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">
                <el-form-item class="no-scroll" prop="address" :required="true">
                    <div class="el-input el-input--prefix"
                        :class="formsData.userForm.address.disabled ? 'is-disabled' : ''">
                        <vue-google-autocomplete id="map" classname="el-input__inner"
                            :ref="(el) => (formsData.userForm.address.ref = el)"
                            v-model="formsData.userForm.address.value.text"
                            autocomplete="off"
                            :placeholder="pageText[addressPageType].inputPlaceholder" v-on:placechanged="setAddressData"
                            @input="setAddress" :country="countryArray" :disabled="formsData.userForm.address.disabled">
                        </vue-google-autocomplete>
                        <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
                    </div>
                </el-form-item>

                <el-form-item v-if="userRole === 'locum'"  prop="apartment_number">
                    <!-- <div class="el-input el-input--prefix"> -->
                    <el-input id="map" classname="el-input__inner"
                        :ref="(el) => (formsData.userForm.apartment_number.ref = el)"
                        v-model="formsData.userForm.apartment_number.value"
                        :disabled="formsData.userForm.apartment_number.disabled" placeholder="Apartment number">
                    </el-input>
                    <!-- </div> -->
                </el-form-item>

                <el-form-item v-if="userRole === 'pharmacy' && addressPageType === 'billingAddress'"
                    label="Billing Email" prop="billing_email">
                    <!-- <div class="el-input el-input--prefix"> -->
                    <el-input id="map" classname="el-input__inner"
                        :ref="(el) => (formsData.userForm.billing_email.ref = el)"
                        v-model="formsData.userForm.billing_email.value"
                        :disabled="formsData.userForm.billing_email.disabled" placeholder="Email for billing">
                    </el-input>
                    <!-- </div> -->
                </el-form-item>

                <el-form-item v-if="userRole === 'pharmacy' && addressPageType === 'billingAddress'" label="Mailbox Number" prop="mailbox_number">
           
                    <el-input id="map" classname="el-input__inner"
                        :ref="(el) => (formsData.userForm.mailbox_number.ref = el)"
                        v-model="formsData.userForm.mailbox_number.value"
                        :disabled="formsData.userForm.mailbox_number.disabled" placeholder="Mailbox number">
                    </el-input>
                </el-form-item>
                <el-form-item v-if="userRole === 'pharmacy'" :label="shopLabel" prop="shop_number">
                    <!-- <div class="el-input el-input--prefix"> -->
                    <el-input id="map" classname="el-input__inner"
                        :ref="(el) => (formsData.userForm.shop_number.ref = el)"
                        v-model="formsData.userForm.shop_number.value"
                        :disabled="formsData.userForm.shop_number.disabled" :placeholder="shopLabel">
                    </el-input>
                    <!-- </div> -->
                </el-form-item>
                <template v-if="userData.role !== 'locum'">
                    <el-form-item v-if="userData.address.lat ? true : false">
                        <el-checkbox v-model="formsData.userForm.address.disabled" @change="onAddressCheckboxChange">Same as
                            {{ messages.employer }} Address
                        </el-checkbox>
                    </el-form-item>
                </template>
                <el-form-item class="button_submit mb0 mt-auto">
                    <el-button class="submit" type="blue" @click="save('userForm')"
                        :disabled="formsData.userForm.disabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>

            
            <div class="background-circles" v-if="isAustralia">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    inject,
  getCurrentInstance,
    computed
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";

addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import addressText from "@/helpers/address/address.js";
import { ElMessageBox } from "@/components/Vendor/Element";
import PageTitle from "@/components/PageTitle/PageTitle.vue";
import { VueGoogleAutocomplete } from "@/components/components";
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';

import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
        VueGoogleAutocomplete,
        SvgIcon
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const googleMaps = inject(["googleMaps"]);
        const instance = getCurrentInstance();
        const isAustralia = isAustraliaRegion();
        const isUS = isUSRegion();


        const userData = $store.getters.GET_USER_DATA;
        console.log('hhshsh',userData);
        const userRole = userData.role;
        const messages = inject('messages');
        const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });

        const pageText = {
            locum: {
                pageTitle: "Home Address",
                formText: "Input your home address so we can show shifts near you",
                inputPlaceholder: "Find your address",
            },
            pharmacy: {
                pageTitle: `${messages.BusinessAddress}`,
                // formText: `Pharmacy address will be used to find ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false) }s nearby`,
                inputPlaceholder: "Find your location",
            },
            billingAddress: {
                pageTitle: "Billing Address",
                formText: "Please provide a mailing address for invoicing",
                inputPlaceholder: "Find your business address",
            },
        };

        const addressPageType =
            $route.name == "auth_billingAddress" ? "billingAddress" : userRole;

        let address = {};

        if (addressPageType == "billingAddress") {
            address = {
                text: userData.billing.address.text || "",
            };
        } else {
            address = {
                text: addressText(userData.address) || "",
                lat: userData.address.lat || "",
                lng: userData.address.lng || "",
            };
        }

        let addressDisabled = ref(false);
        let shopNumberDisabled = ref(false);
        let billingEmailDisabled = ref(false);

        if (addressPageType == "billingAddress") {
            addressDisabled.value =
                userData.address.lat &&
                    userData.billing.address.text &&
                    addressText(userData.address) == userData.billing.address.text
                    ? true
                    : false;
        }

        const formsDataArray = {
            userForm: {
                address: {
                    value: address,
                    valueTemp: "",
                    disabled: addressDisabled.value,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "address",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                shop_number: {
                    value: "",
                    valueTemp: "",
                    disabled: shopNumberDisabled.value,
                },
                mailbox_number: {
                    value: "",
                    valueTemp: "",
                    disabled: shopNumberDisabled.value,
                },
                apartment_number: {
                    value: "",
                    valueTemp: "",
                    disabled: shopNumberDisabled.value,
                },
                billing_email: {
                    value: userData.email ? userData.email :"",
                    valueTemp: "",
                    disabled: billingEmailDisabled.value,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "email",
                                    callback,
                                    setFormValidation
                                );
                            },
                            trigger: ["blur", "enter"],
                        },
                    ],
                },
            },
        };

        const setAddress = () => {
            if (
                formsData.userForm.address.value.text !=
                    formsData.userForm.address.value.temp
            ) {
                formsData.userForm.address.value.text = null;
            }
            checkFormValidation("userForm", true, "address");
        };

        const setAddressData = (addressData, placeResultData) => {
            formsData.userForm.address.value.text = placeResultData.formatted_address;
            console.log(placeResultData);
            formsData.userForm.address.ref.update(
                formsData.userForm.address.valueTemp
            );
            if (addressPageType !== "billingAddress") {
                (async () => {
                    try {
                        formsData.userForm.address.value.lat =
                            addressData.latitude.toString();
                        formsData.userForm.address.value.lng =
                            addressData.longitude.toString();
                        formsData.userForm.address.value.subpremise = (addressData.subpremise ? addressData.subpremise : "") 
                        formsData.userForm.address.value.street =
                            (formsData.userForm.address.value.subpremise
                                ? formsData.userForm.address.value.subpremise + "/"
                                : "") +
                                (addressData.street_number ? addressData.street_number + " " : "") +
                                addressData.route;
                        formsData.userForm.address.value.state =
                            addressData.administrative_area_level_1
                                ? addressData.administrative_area_level_1
                                : "";
                        formsData.userForm.address.value.suburb = addressData.locality
                            ? addressData.locality
                            : "";
                        formsData.userForm.address.value.country = addressData.country
                            ? addressData.country
                            : "";
                        formsData.userForm.address.value.postcode = addressData.postal_code
                            ? addressData.postal_code
                            : "";

                        formsData.userForm.address.value.text =
                            placeResultData.formatted_address;
                        formsData.userForm.address.value.temp =
                            placeResultData.formatted_address;
                        formsData.userForm.address.ref.update(
                            formsData.userForm.address.value.text
                        );
                        const timezone = await googleMaps.getTimeZone(
                            formsData.userForm.address.value.lat +
                                "," +
                                formsData.userForm.address.value.lng
                        );
                        formsData.userForm.address.value.timezone = timezone.timeZoneId;

                        console.log(formsData.userForm.address.value);
                    } catch (error) {
                        console.log(error);
                    }
                })();
            }
            checkFormValidation("userForm", true, "address");
        };

        const onAddressCheckboxChange = () => {
            if (formsData.userForm.address.disabled) {
                formsData.userForm.address.valueTemp =
                    formsData.userForm.address.value.text;
                formsData.userForm.address.value.text = addressText(userData.address);
                formsData.userForm.address.ref.update(addressText(userData.address));
                formsData.userForm.address.disabled = true;

                formsData.userForm.shop_number.valueTemp =
                    formsData.userForm.shop_number.value;
                formsData.userForm.shop_number.value = userData.address.shopNumber;

                formsData.userForm.shop_number.disabled = true;

                formsData.userForm.mailbox_number.valueTemp =
                    formsData.userForm.mailbox_number.value;
                formsData.userForm.mailbox_number.value = userData.address.mailboxNumber;

                formsData.userForm.mailbox_number.disabled = false;
                console.log(true);
            } else {
                formsData.userForm.address.value.text =
                    formsData.userForm.address.valueTemp;
                formsData.userForm.address.ref.update(
                    formsData.userForm.address.valueTemp
                );
                formsData.userForm.shop_number.value =
                    formsData.userForm.shop_number.valueTemp;
                formsData.userForm.shop_number.disabled = false;
                formsData.userForm.mailbox_number.value =
                    formsData.userForm.mailbox_number.valueTemp;
                formsData.userForm.mailbox_number.disabled = false;
                formsData.userForm.address.disabled = false;
                console.log(false);
            }
            checkFormValidation("userForm", true, "address");
        };

        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });           
        };

        const goNext = () => {
            if (process.env.VUE_APP_REGION === 'US') {
                if (addressPageType === "billingAddress") {
                    if(instance?.appContext.config.globalProperties.$filters.employerType(userData)){
                        $router.push({ name: "auth_pharmacy_license" });
                    }else{
                        $router.push({ name: "intro" });
                    }
                   
                } else if (addressPageType === "locum") {
                    $router.push({ name: "auth_gender" });
                } else {
                    if(instance?.appContext.config.globalProperties.$filters.employerType(userData)){
                    $router.push({ name: "auth_billingAddress" });
                    }else{
                        $router.push({ name: "intro" });
                    }
                }
            } else {
                // Assume Australia by default
                if (addressPageType === "billingAddress") {
                    if(instance?.appContext.config.globalProperties.$filters.employerType(userData).isValid && instance?.appContext.config.globalProperties.$filters.employerType(userData).isCommunityPharmacy){
                        $router.push({ name: "auth_gallery" });
                    } else {
                        $router.push({ name: "intro" });
                    }
                } else if (addressPageType === "locum") {
                    $router.push({ name: "auth_business" });
                } else {
                    if(instance?.appContext.config.globalProperties.$filters.employerType(userData).isValid && instance?.appContext.config.globalProperties.$filters.employerType(userData).isCommunityPharmacy){
                        $router.push({ name: "auth_billingAddress" });
                    } else if (instance?.appContext.config.globalProperties.$filters.employerType(userData).isValid && instance?.appContext.config.globalProperties.$filters.employerType(userData).isHospitalPharmacy){
                        $router.push({ name: "hospital_pharmacy_information_1" });
                    }else{
                        $router.push({ name: "intro" });
                    }
                }
            }
        };

        const save = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            let data = getFormValues(formName);
                            if (addressPageType == "billingAddress") {
                                data = {
                                    billingMailbox: data.mailbox_number,
                                    billingAddress: data.address,
                                    billingEmail: data.billing_email,
                                };
                            }
                            await $store.dispatch("SAVE_USER_DATA", data);
                            goNext();
                        } catch (error) {
                            console.log("error submit!!");
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                if(userData.isImported == 0){
                    if(userData.role == 'pharmacy' && instance?.appContext.config.globalProperties.$filters.employerType(userData).isCommunityPharmacy){
                        try {
                            await ElMessageBox.confirm(
                                ``,
                                "Do you want to skip? You will be unverified",
                                {
                                    distinguishCancelAndClose: true,
                                    showConfirmButton: true,
                                    confirmButtonText: "Skip",
                                    cancelButtonText: "Cancel",
                                    confirmButtonClass: "el-button--green",
                                    cancelButtonClass: "el-button--grey",
                                    showClose: true,
                                }
                            );
                        } catch {
                            return;
                        }

                        try {
                            await $store.dispatch("addAuthPageBack", $route.name);
                            goNext();
                        } catch (error) {
                            console.log(error);
                        }
                    }else if(userData.role == 'locum'){
                        try {
                            await ElMessageBox.confirm(
                                ``,
                                "Do you want to skip? You will be unverified",
                                {
                                    distinguishCancelAndClose: true,
                                    showConfirmButton: true,
                                    confirmButtonText: "Skip",
                                    cancelButtonText: "Cancel",
                                    confirmButtonClass: "el-button--green",
                                    cancelButtonClass: "el-button--grey",
                                    showClose: true,
                                }
                            );
                        } catch {
                            return;
                        }

                        try {
                            await $store.dispatch("addAuthPageBack", $route.name);
                            goNext();
                        } catch (error) {
                            console.log(error);
                        }
                       
                    }else{
                        try {
                            await $store.dispatch("addAuthPageBack", $route.name);
                            goNext();
                        } catch (error) {
                            console.log(error);
                        }
                    }
                   
                   
                    
                } else {
                    try {
                        await $store.dispatch("addAuthPageBack", $route.name);
                        goNext();
                    } catch (error) {
                        console.log(error);
                    }
                }
              
            })();
        };

        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            setFormRefs();
            if(userData.address.country && userData.address.state ) {
                formsData.userForm.address.ref.update(
                    formsData.userForm.address.value.text
                );
            }
            delete formsData.userForm.billing_email.validators;
            checkFormValidation("userForm", false);
            if (!formsData.userForm.shop_number.value) {
                formsData.userForm.shop_number.value = userData.address.shopNumber;
            }
            if (!formsData.userForm.mailbox_number.value) {
                formsData.userForm.mailbox_number.value = userData.address.mailboxNumber;
            }
            
        });

        const shopLabel = computed(() => {
            if (isAustralia.value) return 'Shop Number';
            if (isUS.value) return 'Unit Number';
            return 'Unit Number'; // Default
        });

        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            userData,
            formsData,
            goBack,
            save,
            skip,
            setAddressData,
            setAddress,
            onAddressCheckboxChange,
            pageText,
            addressPageType,
            userRole,
            countryArray,
            isAustralia,
            messages,
            instance,
            isUS,
            shopLabel
        };
    },
};
</script>
